<i18n
  src="@/locales/views/agro_exporter/production/query_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-truck-container"></i><span class="space-icon"></span
      >{{ $t("labels.containers_title") }}
    </h1>
    <div class="flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="
            statsContainers.total + ' ' + $t('labels.total_number_containers')
          "
        />
        <span class="space-actions" />
        <container-status
          :status_id="0"
          :prepend_label="' ' + statsContainers.by_status[0]"
        />
        <span class="space-actions" />
        <container-status
          :status_id="1"
          :prepend_label="' ' + statsContainers.by_status[1]"
        />
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.status") }}
                  </th>
                  <th
                    v-if="display_packing_house"
                    scope="col"
                    class="table-header-cell"
                  >
                    {{ $t("model.container.packing_house") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.load_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                  <th
                    v-for="container_attribute in agro_exporter_process.container_attributes"
                    :key="container_attribute.id"
                    scope="col"
                    class="table-header-cell"
                  >
                    {{ container_attribute.name }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    <i class="fa-solid fa-paperclip"></i>
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.exportation") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">{{ container.week }}</td>
                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShowContainer(container.id)"
                  >
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    <container-status :status_id="container.status_id" />
                  </td>
                  <td v-if="display_packing_house" class="table-cell">
                    {{ container.packing_house_names.join(", ") }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.load_date) }}
                  </td>
                  <td class="table-cell">
                    {{ container.customer?.name }}
                  </td>
                  <td
                    v-for="container_attribute in agro_exporter_process.container_attributes"
                    :key="container_attribute.id"
                    class="table-cell"
                  >
                    {{
                      containerAttributeValue(container, container_attribute)
                    }}
                  </td>
                  <td class="table-cell">
                    {{ container.num_attachments }}
                  </td>
                  <td class="table-cell">
                    <exportation-type
                      v-if="container.exportation != null"
                      :exportation_type_id="
                        container.exportation.exportation_type_id
                      "
                      :only_icon="true"
                    />
                  </td>
                  <td
                    class="table-cell link"
                    v-if="container.exportation_id"
                    @click.prevent="
                      goToShowExportation(container.exportation_id)
                    "
                  >
                    {{
                      container.exportation
                        ? container.exportation.booking_code
                        : ""
                    }}
                  </td>
                  <td class="table-cell" v-else></td>
                  <td class="table-cell-action">
                    <container-details
                      :container="container"
                      icon="fa-solid fa-eye"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <table-paginator
      v-model="current_page"
      :total_rows="statsContainers.total"
      :rows_per_page="rowsPerPage.containers"
    />
  </div>
</template>

<script>
import ContainerDetails from "@/components/views/agro_exporter/production/shared/container/ContainerDetails.vue";
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import ShowProcessTabsMixin from "@/components/views/agro_exporter/production/query_container_export/show_process/show_process_tabs_mixin.js";

export default {
  name: "ShowProcessContainers",
  mixins: [ShowProcessTabsMixin],
  components: {
    ContainerStatus,
    ExportationType,
    ContainerDetails,
    TablePaginator
  },
  data() {
    return {
      current_page: this.currentPage.containers
    };
  },
  props: {
    agro_exporter_process: { required: true },
    containers: { type: Array, required: true },
    currentPage: {
      type: Object,
      default: () => {
        return { containers: 1 };
      }
    },
    rowsPerPage: {
      type: Object,
      default: () => {
        return { containers: 12 };
      }
    },
    statsContainers: {
      tpye: Object,
      default: () => {
        return { total: 0, by_status: {} };
      }
    }
  },
  computed: {
    display_packing_house: function () {
      let packing_houses = new Set();
      this.containers.forEach(container => {
        container.packing_house_names.forEach(packing_house => {
          packing_houses.add(packing_house);
        });
      });
      return packing_houses.size > 1;
    }
  },
  watch: {
    current_page: function (newValue) {
      let current_page = this.currentPage;
      current_page.containers = newValue;
      this.$emit("update:currentPage", current_page);
    }
  },
  methods: {
    containerAttributeValue: function (container, container_attribute) {
      return container.container_attribute_values.find(
        value =>
          value.exporter_process_container_attribute_id ===
          container_attribute.id
      )?.value;
    },

    goToShowContainer: function (container_id) {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container_id
        }
      });
    },
    goToShowExportation: function (exportation_id) {
      this.$router.push({
        name: this.routeName("show_exportation"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          exportation_id: exportation_id
        }
      });
    }
  }
};
</script>
